import {Component, EventEmitter, Inject, Input, OnInit, forwardRef} from '@angular/core';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';

import {BeachesService} from '../beaches/beaches.service';
import {PreCERCLISService} from '../services/pre-cerclis.service';
import {SolidWasteService} from '../solid-waste/solid-waste.service';
import {ContactsService} from '../contacts/contacts.service';
import {TierIIService} from '../services/tierii.service';
import {BrownfieldsService} from '../services/brownfields.service';
import {PesticidesService} from '../services/pesticides.service';
import {FUDSService} from '../services/fuds.service';
import {UstService} from '../ust/ust.service';
import {StandbyGeneratorsService} from '../standby-generators/standby-generators.service';
import {OneStopService} from '../one-stop/one-stop.service';
import {ERService} from '../services/er.service';
import {ComplaintsService} from '../services/complaints.service';
import {ActivatedRoute} from '@angular/router';
import {ExpandCollapseComponent} from '../expand-collapse/expand-collapse.component';
import {AddProgramButtonComponent} from '../add-program-button/add-program-button.component';
import {AsyncPipe, NgIf} from '@angular/common';
import {EmissionsChartComponent} from '../standby-generators/emissions-chart/emissions-chart.component';
import {MapWithInputComponent} from '@shared/map-with-input/map-with-input.component';
import {SearchComponent} from '@shared/search/search.component';
import {NestedInlineComponent} from '@shared/inlines/nested/nested-inline.component';
import {InterestInlineComponent} from '@shared/inlines/interest-inline/interest-inline.component';
import {ReverseInlineComponent} from '@shared/inlines/reverse-inline/reverse-inline.component';
import {GenericInlineComponent} from '@shared/inlines/generic/generic.component';
import {HistoryService} from '@shared/services/history.service';
import {SitesService} from '@shared/services/sites.service';
import {ParcelService} from '@shared/services/parcel.service';
import {MapService} from '@shared/services/map.service';

// import {WaterSamplingService} from '../water-sampling/water-sampling.service';

@Component({
    selector: 'app-site-details',
    templateUrl: './site-details.component.html',
    styleUrls: ['./site-details.component.css'],
    imports: [
        MapWithInputComponent,
        SearchComponent,
        ExpandCollapseComponent,
        AddProgramButtonComponent,
        NgIf,
        NestedInlineComponent,
        InterestInlineComponent,
        AsyncPipe,
        ReverseInlineComponent,
        EmissionsChartComponent,
        GenericInlineComponent
    ]
})
export class SiteDetailsComponent implements OnInit {
  id;

  public history: Observable<any[]>;
  public historyMeta: any;
  public loadRelatedBeach: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public Beaches: BeachesService, public PreCERCLIS: PreCERCLISService,
              public SolidWaste: SolidWasteService, public Contacts: ContactsService,
              public TierII: TierIIService, public historyService: HistoryService,
              public Brownfields: BrownfieldsService, public Pesticides: PesticidesService,
              public FUDS: FUDSService, public UST: UstService, public StandbyGenerators: StandbyGeneratorsService,
              public OneStop: OneStopService, public ER: ERService, public Complaints: ComplaintsService,
              public mapService: MapService,
              public Parcels: ParcelService, public siteService: SitesService,
              public route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params.id;
      this.getHistory();
    })


  }

  getHistory() {
    this.historyMeta = {
      verbose_name_plural: 'Site History',
      verbose_name: 'Site History'
    };
    this.siteService.loadMetadata().pipe(tap(meta => {
      this.historyMeta = meta;
      this.historyMeta.display_fields = [
        'name', 'site_id', 'parcel_id', 'streetaddress', 'supplemental_location', 'village', 'classification',
        'horizontal_collection_method', 'last_edited_user', 'last_edited_date'
      ];
      this.historyMeta.verbose_name_plural = 'Site History';
      this.historyMeta.permissions.write = false;
    })).subscribe();
    this.history = this.siteService.get<any>(`${this.id}/history`).pipe(tap(results => {
      this.historyMeta.count = results.length;
    }));
  }

}
